"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const filters_1 = require("../../constants/filters");
const hooks_1 = require("../../hooks");
const EmptyGroupList_1 = __importDefault(require("../../molecules/EmptyGroupList"));
const GroupList_1 = __importDefault(require("../GroupList"));
const GroupDetailsMobile_1 = __importDefault(require("../GroupDetailsMobile"));
const GroupsManagementPanel_1 = __importDefault(require("../GroupsManagementPanel"));
function GroupsManagementMobile({ groups, isMobile, }) {
    const sharingService = (0, hooks_1.useSharing)();
    const { search = '' } = (0, ui_1.useTabsContext)();
    const [filteredGroups, setFilteredGroups] = (0, react_1.useState)(groups);
    const [filters, setFilters] = (0, react_1.useState)(filters_1.sharingFilter);
    const [isDetailsOpened, setDetailsOpened] = (0, react_1.useState)(false);
    const [currentGroup, setCurrentGroup] = (0, react_1.useState)(null);
    const searchGroups = (groupsToFilter) => {
        return groupsToFilter
            .filter(({ canLeave }) => canLeave)
            .filter(({ name }) => name.toLowerCase().includes(search.toLowerCase()));
    };
    const onSelect = (group) => {
        sharingService === null || sharingService === void 0 ? void 0 : sharingService.updateLastActivityTime(group.identifier);
        setCurrentGroup(group);
        setDetailsOpened(true);
    };
    const setIsClosed = () => {
        setDetailsOpened(false);
        setTimeout(() => {
            setCurrentGroup(null);
        }, 500);
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'GroupsManagementMobile_Container', children: [currentGroup && ((0, jsx_runtime_1.jsx)(GroupDetailsMobile_1.default, { group: currentGroup, isOpen: isDetailsOpened, setIsClosed: setIsClosed, "data-e2e": 'GroupsManagementMobile_GroupDetailsMobile' })), (0, jsx_runtime_1.jsx)(GroupsManagementPanel_1.default, { groups: groups, filteredGroups: searchGroups(filteredGroups), setFilteredGroups: setFilteredGroups, filters: filters, setFilters: setFilters, "data-e2e": 'GroupsManagementMobile_GroupsManagementPanel' }), !searchGroups(filteredGroups).length ? ((0, jsx_runtime_1.jsx)(EmptyGroupList_1.default, { "data-e2e": 'GroupsManagementMobile_EmptyGroupList' })) : ((0, jsx_runtime_1.jsx)(GroupList_1.default, { title: (0, i18n_1.Localized)(i18n_1.Strings.settings.sharing.myGroups), groups: searchGroups(filteredGroups), selected: currentGroup === null || currentGroup === void 0 ? void 0 : currentGroup.identifier, onSelect: onSelect, showCreateGroupButton: false, isMobile: isMobile, "data-e2e": 'GroupsManagementMobile_GroupList' }))] }));
}
exports.default = GroupsManagementMobile;
const Container = styled_components_1.default.div `
  position: relative;
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;

  overflow: hidden;
`;
